// extracted by mini-css-extract-plugin
export default {"createdInfo":"CreatedInfo_createdInfo__fhqom","createdInfo__text":"CreatedInfo_createdInfo__text__lJPpf"};